
import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import EventBus from '@/eventBus'
import router from '@/router'

@Component
export default class NptSettings extends Vue {
    @Prop({})
    canDeleteMultiple!: Boolean;
    
    error: any = {
        generalMessage: '',
        errors: []
    }
    activeScreen: string = 'main'
    successMessage: string = ''
    additionalSuccessMessage: string = ''
    loadingMessage: string = ''
    loadingTitle: string = ''
    wellFields: any[] = [{ key: 'selectRow', label: 'Select', sortable: false, thStyle: { width: "60px" } }, 'propertyName', 'backgroundColor', 'action']
    nptSettingsFields: any[] = [{ key: 'selectRow', label: 'Select', sortable: false, thStyle: { width: "60px" } }, 'nptCategory', 'rootCauses', 'action']
    activeItem: any = null
    nptSettingsForm = {
        nptCategory: "",
        rootCauses: ""
    }
    nptRootCausesList = []
    showPreview: boolean = false
    uploadedPhoto!: any
    selectAllNptSettings: boolean = false
    selectedNptSettingsRows: { name: string; id: string }[] = []
    deleteNptSettingsPromptProperty: boolean = false

    get fetchNptSettings() {
        return this.$store.dispatch('settingsModule/getNptSettings')
    }

    get nptSettings() {
        return this.$store.getters['settingsModule/getNptSettings']
    }

    get validNPTSettings() {
        return this.nptSettings.filter((setting: any) => setting != null).sort((a: any, b: any) => {
            const itemA = (a.nptCategory || '').toString().toLowerCase().trim();
            const itemB = (b.nptCategory || '').toString().toLowerCase().trim();
            return itemA.localeCompare(itemB, undefined, {
                sensitivity: 'base',
                numeric: true
            });
        });
    }

    editColor(data: any) {
        this.activeItem = data
        let modalColor = this.$refs.bvColor as any
        modalColor.show()
    }

    promptNptSettingsDelete(item: any) {
        this.activeItem = item;
        this.deleteNptSettingsPromptProperty = true
    }

    toggleSelectAllNptSettings() {
        if (!this.selectAllNptSettings) {
            this.selectedNptSettingsRows = this.nptSettings.map((setting: any) => ({ id: setting.id, name: setting.nptCategory }))
        } else {
            this.selectedNptSettingsRows = []
        }
        this.$emit('npt-checks', {nptAllSetting: this.selectAllNptSettings ? false : true, nptAllSettingsRows: this.selectedNptSettingsRows})
    }

    editNptSettings(id: number) {
        this.$router.push('/manage-npt-settings/?id=' + id.toString())
    }
    getNPTSettingsToDelete() {
        const names = this.selectedNptSettingsRows.map(row => row.name);

        let formattedNames = '';
        if (names.length <= 3) {
            const lastTwoNames = names.splice(-2);
            if (this.selectedNptSettingsRows.length === 2) {
                return formattedNames = `${names.join(', ')} ${lastTwoNames.join(' and ')}`;
            }
            return formattedNames = `${names.join(', ')}, ${lastTwoNames.join(' and ')}`;
        }
        else {
            const firstTwoNames = names.slice(0, 2);
            const remainingCount = names.length - 2;
            return `${firstTwoNames.join(', ')} and ${remainingCount} other${remainingCount > 1 ? 's' : ''} NPT setting${remainingCount > 1 ? 's' : ''}`;
        }
    }

    doDeleteNPTSettings() {
        const isMultipleDelete = this.selectedNptSettingsRows.length;
        this.activeScreen = 'loading'
        EventBus.$emit('activeScreen', this.activeScreen)
        this.loadingMessage = `Please wait while we delete ${isMultipleDelete ? 'these NPT Settings' : 'this NPT Setting'}`
        this.loadingTitle = 'Deleting...'

        const payload = isMultipleDelete ? this.selectedNptSettingsRows.map(row => row.id) : [this.activeItem.id]
        this.$store.dispatch('settingsModule/deleteNptSettings', payload)
            .then((res: any) => {
                this.activeScreen = 'successNoBack'
                EventBus.$emit('activeScreen', this.activeScreen)
                this.additionalSuccessMessage = `${isMultipleDelete ? 'These NPTSettings' : 'This NPT Settings'} will no longer be available`
                this.successMessage = `${isMultipleDelete ? 'Deleted Successfully' : this.activeItem.nptCategory} Deleted Successfully`
                this.deleteNptSettingsPromptProperty = false
                this.$emit('can-delete-multiple', false);
            })
            .catch((error: any) => {
                this.activeScreen = 'error'
                EventBus.$emit('activeScreen', this.activeScreen)
                this.error = error.message
                this.deleteNptSettingsPromptProperty = false
            })
    }

    @Watch('selectedNptSettingsRows', { immediate: true })
    onselectedNptSettingsRowsChanged() {
        this.$emit('npt-checks', {nptAllSetting: false, nptAllSettingsRows: this.selectedNptSettingsRows});
    }

    @Watch('canDeleteMultiple', { immediate: true })
    oncanDeleteMultipleChanged() {
        if (this.selectedNptSettingsRows.length) {
            this.deleteNptSettingsPromptProperty = this.canDeleteMultiple as boolean;
        }
    }

    mounted() {
        this.fetchNptSettings.then(() => {
            if (this.$route.query.id) {
                this.activeItem = this.nptSettings.find((i: any) => i.id == this.$route.query.id)
            }
        });
    }
}
